import { Box } from "@mui/material";

export interface SpacerProps {
	gap: 0 | 8 | 16 | 24 | 32 | 40 | 48 | 56;
}

export const Spacer = ({ gap }: SpacerProps) => {
	return <Box sx={{ marginTop: `${gap}px` }}></Box>;
};
